import React from "react";

// 🔷 Components Import
import Newhome from "./Newhome"; // Header + Banner

import Newhomefooter from "./Newhomefooter";
import UserManual from "./UserManual";

const Usearmanualpage = () => {
  return (
    <>
    <div className="home-page-new">
      {/* 🔷 HEADER + HERO */}
      <Newhome />

      {/* 🔷 Screen Reader */}
    
      <UserManual />
      <Newhomefooter />
      </div>
    </>
  );
};

export default Usearmanualpage;